import React, {useEffect, useRef, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers';
import { Box, Button, Popover } from '@mui/material';
import dayjs from 'dayjs';
import EventIcon from '@mui/icons-material/Event';
import styles from './CustomDateCellEditor.module.css';


export function CustomDateCellEditor(params) {
  if (params==undefined)
  return
    const { onValueChange, api, eGridCell, eventKey, rowIndex, column,colDef } = params?.isEditRowPopup?params.params:params;
  const KEY_BACKSPACE = 'Backspace';
  const inputRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [calendarView, setCalendarView] = useState('day');
  let isStrictDate = colDef.listData || false

  function formatDate(date) {
    if (!date) {
      return { value: isStrictDate ? "" : date, isDate: false };
    }

    // Check if the input is a string containing numbers
    if (typeof date === 'string' && /\d/.test(date)) {
      // Define regular expressions for supported date formats
      const dateRegexes = [
        /^\d{4}-\d{2}-\d{2}$/,
        /^\d{1,2}[/-]\d{1,2}[/-]\d{4}$/
      ];

      // Check if the input matches any of the supported date formats
      const isValidFormat = dateRegexes.some(regex => regex.test(date));

      if (!isValidFormat) {
        return { value: date, isDate: false };
      }

      // Parse the date based on the detected format
      let parsedDate;
      if (date.includes('-')) {
        parsedDate = new Date(date.replace(/-/g, '/'));
      } else {
        parsedDate = new Date(date);
      }

      if (isStrictDate) {
        return { value: date, isDate: true }
      }
      // Check if the parsed date is valid
      if (isNaN(parsedDate.getTime())) {
        return { value: "Invalid Date", isDate: false };
      }

      // Check if the date exceeds the length of a valid date string
      if (date.trim().length > 10) {
        return { value: 'Invalid Date', isDate: false };
      }

      // Format the date as MM/DD/YYYY
      const formattedDate = `${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}/${parsedDate.getDate().toString().padStart(2, '0')}/${parsedDate.getFullYear()}`;
      const newDate = `${(parsedDate.getMonth() + 1).toString().padStart(2, '0')}/${parsedDate.getDate().toString().padStart(2, '0')}/${parsedDate.getFullYear()}`;
      return { value: isStrictDate ? formattedDate : newDate, isDate: true };
    } else {
      // Return the input as is if it's not a string containing numbers
      return { value: date.toString(), isDate: false };
    }
  }

  const [value,setValue]=useState(formatDate(params.isEditRowPopup?params.params.value:params.value).value)

  const updateValue = (val) => {
    setValue(val)
    let value;
    if (val.toLowerCase() === "yesterday") {
      value = dayjs().subtract(1, 'day').format('MM/DD/YYYY')
    }
    else if (val.toLowerCase() === "today") {
      value = dayjs().format('MM/DD/YYYY')
    }
    else if (val.toLowerCase() === "tomorrow") {
      value = dayjs().add(1, 'day').format('MM/DD/YYYY')
    }
    else if (val !== "" && val !== null) {
      value = val;
    }
    else value = "";
   if(!params.isEditRowPopup) onValueChange(value === '' ? null : value);
   else params.updateDB(value === '' ? null : value)
    //updateRowDHelper(value === '' ? null : value)
  };


  useEffect(() => {
    let startValue;
    if (eventKey === KEY_BACKSPACE) {
      startValue = '';
    } else if (eventKey && eventKey.length === 1) {
      startValue = eventKey;
    } else {
      startValue = value;
    }
    if (startValue == null) {
      startValue = '';
    }

    updateValue(startValue);

    inputRef.current.focus();
  }, []);

  useEffect(() => {
    inputRef.current.focus(); 
    inputRef.current.select();
  }, [inputRef, anchorEl])

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCalendarDateChange = (value) => {
    let formattedInput = value.format('MM/DD/YYYY')
    updateValue(formattedInput);
    if (calendarView === "day") {
      handlePopoverClose()
    }
 
    if(params.isEditRowPopup)params.onClose()
  }

  const handlePopoverClose = () => {
    setAnchorEl(null);
    if(params.isEditRowPopup)params.onClose()
  };


  const getColumnWidth = () => {
    const columnWidth = api.getColumn(column.colId);
    return columnWidth.actualWidth;
  };

  const handleClear = () => {
    updateValue("")
    handlePopoverClose()
  }

  const handleYesterday = () => {
    const yesterday = dayjs().subtract(1, 'day').format('MM/DD/YYYY')
    updateValue(yesterday)
    handlePopoverClose()
  }

  const handleToday = () => {
    const today = dayjs().format('MM/DD/YYYY')
    updateValue(today)
    handlePopoverClose()
  }
  const handleTomorrow = () => {
    const tomorrow = dayjs().add(1, 'day').format('MM/DD/YYYY')
    updateValue(tomorrow)
    handlePopoverClose()
  }
  return (
    <div
      className={styles.container}
      style={{
        width: params.isEditRowPopup ? '100%' : getColumnWidth(),
      }}
    >
      <input
        type='text'
        ref={inputRef}
        maxLength={25}
        value={value}
        onChange={(e) => updateValue(e.target.value)}
        className={`${styles.input} ${
          params.isEditRowPopup ? styles.popupInput : styles.gridInput
        }`}
        style={{
          minHeight: params.isEditRowPopup
            ? 40
            : eGridCell.clientHeight + 4,
          width: params.isEditRowPopup ? '100%' : getColumnWidth(),
        }}
      />
      <EventIcon
        onClick={handlePopoverOpen}
        className={styles.icon}
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        disablePortal={true}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateCalendar
            onChange={handleCalendarDateChange}
            onViewChange={(newView) => {setCalendarView(newView)}}
            value={value !== "" && value !== null ? dayjs(value) : null}
            sx={{ height: "16.5rem" }}
            minDate={dayjs("01/01/1900")}
            maxDate={dayjs("12/31/2099")}
          />
        </LocalizationProvider>
        <Box className={styles.footer}>
          <Button onClick={handleClear} className={styles.smallBtn}>
            Clear
          </Button>

          <Box className={styles.footerRight}>
            <Button onClick={handleYesterday} className={styles.smallBtn}>
              Yesterday
            </Button>
            <Button onClick={handleToday} className={styles.smallBtn}>
              Today
            </Button>
            <Button onClick={handleTomorrow} className={styles.smallBtn}>
              Tomorrow
            </Button>
          </Box>
        </Box>
      </Popover>
    </div>
  );
};